import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    headerStyle: 'light'
  },
  mutations: {
    setHeaderStyle(state, payload) {
      state.headerStyle = 'light'
    }
  },
  actions: {
  },
  modules: {
  }
})
